import request from '../request'
const AI_API = (process.env.NODE_ENV == 'development' ? '/ai' : process.env.AI_API)

/**
 * AI 写简历
 * @param {string} text
 * @param {number} text_type 1简历润色 2自动写
 * @returns 
 */
export const getAIWriteResult = (data)=>{
	return request({
		url: `${AI_API}/cv/v3/ai_cvs`,
		method: 'POST',
		data,
    timeout: 60000
	})
}

/**
 * 获取 AI 模板内
 * @param {string} experience
 * @param {string} job_type
 * @param {string} page
 * @param {string} size
 * @returns 
 */
export const getWriteResult = (params)=>{
	return request({
		url: `${AI_API}/cv/v3/ai_cvs/template_result`,
		method: 'GET',
		params,
    timeout: 60000
	})
}

/**
 * AI简历润色
 */

export const getAIOptimizationResult = (data) => {
	return request({
		url: `${AI_API}/cv/v3/ai_cvs/cv_optimization`,
		method: 'POST',
		data,
    timeout: 60000
	})
}
